import { render } from "./Footer.vue?vue&type=template&id=665c5af0&scoped=true"
const script = {}

import "./Footer.vue?vue&type=style&index=0&id=665c5af0&scoped=true&lang=css"

import exportComponent from "C:\\Users\\dymek\\Desktop\\Projects\\Lusterka Adam\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-665c5af0"]])

export default __exports__